/**
 * Age in whole years from a `YYYY-MM-DD` birth date.
 *
 * Returns null for an empty/unset date so callers can pass the result straight
 * to the nullable `profiles.age` column — that column is numeric, and sending
 * `''` to it fails with `invalid input syntax for type numeric: ""`.
 */
export function calculateAge(birthDate: string, today: Date = new Date()): number | null {
  if (!birthDate) return null;
  const birth = new Date(birthDate);
  if (Number.isNaN(birth.getTime())) return null;
  let age = today.getFullYear() - birth.getFullYear();
  const monthDiff = today.getMonth() - birth.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
    age--;
  }
  return age;
}
